import _ from 'lodash';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { inject } from 'mobx-react';

@inject('userStore')
class Navigation extends React.Component {
	state = {};

	render () {
		const isActive = (match) => _.isNull(match) !== true;
		const { active } = this.state;

		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ active === activeSlug ? 'active' : '' }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		return (
			<nav>
				<ul className="menu horizontal" style={{marginRight:'1vw'}}>
					<li><LinkItem label="Profile" activeSlug="" to="/" /></li>
					<li><LinkItem label="+Tracks" activeSlug="music" to="/bands/music" /></li>
					<li><LinkItem label="+Albums" activeSlug="albums" to="/bands/albums" /></li>
					{/* <li><LinkItem label="Photos" activeSlug="photos" to="/bands/photos" /></li> */}

					<li><LinkItem label="Dashboard" activeSlug="bio" to="/bands/dashboard" /></li>
					<li><a href="#" onClick={ () => this.props.userStore.logout() }>Logout</a></li>
				</ul>
			</nav>
		);
	}
}

export default Navigation;
